import { render, staticRenderFns } from "./SoshMobileRecovery.vue?vue&type=template&id=14afd2bc&scoped=true"
import script from "./SoshMobileRecovery.vue?vue&type=script&lang=js"
export * from "./SoshMobileRecovery.vue?vue&type=script&lang=js"
import style0 from "./SoshMobileRecovery.vue?vue&type=style&index=0&id=14afd2bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14afd2bc",
  null
  
)

export default component.exports